const AiFredSocketEventNamespace = "aifred";
const AiFredSocketEventTypeNames = ["new_message"] as const;
type AiFredSocketEventTypeName = (typeof AiFredSocketEventTypeNames)[number];

export { AiFredSocketEventNamespace, AiFredSocketEventTypeNames };
export type { AiFredSocketEventTypeName };
